import {Calculator} from '../calculator';

class StatedutyCalculator extends Calculator {
    initialize() {
        let self = this;

        this.setupStatistic({
            calcName: this.calcName,
            printMessage: ()  => ({
                message: "Print", 
                args: {
                    claim_type: this.getHash() + '_' + this.calcName
                }
            }),
            exportMessage: () => ({
                message: "Export", 
                args: {
                    claim_type: this.getHash() + '_' + this.calcName
                }
            }),
            isStartedEventIgnore: true
        });

        this.submitOnChange();
        this.addInputField(".main-duty-block-body .sum-field input", "dutyValInput", {
            type: "money",
            options: {keyup: true, maxVal: 999999999999.99 },
        });
        this.addInputField(".checkboxrow-opt-1", "optionFirst");
        this.addInputField("#calcOpt2CheckboxRow", "optionSecond");
        $("input").focus(tools.selectAllText).val(0);

        this.activeSubMenu = "";

        this.drawLines();
        $(window).on('resize scroll', this.drawLines);

        function closeSubMenu() {
            self.activeSubMenu = "";
            self.autoSubmit(null, true);
        }

        $(".submenu-item").click(closeSubMenu);
        $("#popupSubmenu .close-button").click(closeSubMenu);
        $(document).click(e => { //todo
            if ($(e.target).hasClass("body-wrapper")) {
                closeSubMenu();
            }
        });

        const fadeDuration = 100;
        $(".exemption-link").click(() => {
            $('#popupExemption').fadeIn(fadeDuration);
            let goalParams = {
                message: "Priveleges",
                prefix: "",
                args: {
                    claim_type : self.getHash() + '_' + this.calcName
                }
            };
            self.sendStatisticMessage(goalParams);

            $('body').addClass('body-wrapper-fixed');
        });

        const closePopupExemption = (fadeDuration) => {
            $('#popupExemption').fadeOut(fadeDuration);
            $('body').removeClass('body-wrapper-fixed');
        }

        $(document).mousedown(e => {
            const $popupExemption = $('#popupExemption');
            const $popupExemptionBody = $('#popupExemption > div');
            const $closeButton = $('#popupExemption').find(".close-button");
        
            if ($popupExemption.is(":visible")) {
                if ($(e.target).is($closeButton)) {
                    closePopupExemption(fadeDuration);
                }
                if (!$popupExemptionBody.is(e.target) && $popupExemptionBody.has(e.target).length === 0) {
                    if (!$popupExemption.is(e.target) || e.offsetX < $popupExemption[0].clientWidth) {
                        closePopupExemption(fadeDuration);
                    }
                }
            }
        });

        $(window).on("hashchange", (e) => {
            $("input").val(0);
            $('#calcOpt1Checkbox, #calcOpt2Checkbox, #calcOpt3Checkbox').each(function () {
                var $checkboxItem = $(this);
                if ($checkboxItem.is(':checked')) {
                    $checkboxItem.prop("checked", false);
                }
            });
            
            this.opt1Input = 0;
            this.opt3Input = 0;
            this.showAllHeader = false;
            this.openCalcByHash();
            this.autoSubmit(null, true);
        });

        /*
            TODO : move autoSubmit() to another part of code
            These lines provides proper export under different conditions in 'ifHash'
        */
        $("#wordResult").mousedown(() => this.autoSubmit());
    }

    // TODO: find some better fix for the export - this one is a dirty kludge
    autoSubmit(sender, skipValueChangesCheck) {
        super.autoSubmit(sender, skipValueChangesCheck);
        super.autoSubmit(sender, skipValueChangesCheck);
    }

    generateExportObject() {
        let result = super.generateExportObject();
        result.render.permanentNote = $(".permanent-note:visible").length ? tools.convertElemToTextWithLinksForExport($(".permanent-note")) : "";
        result.render.tabHeaderOpt1 = $('#calcOpt1Block .duty-block-tabs .active-tab').text();
        result.render.mainBlockComment  = $("#calcComment div:visible p:visible").toArray()
        .map((comment) => tools.convertElemToTextWithLinksForExport(comment))
        .join("||");
        result.render.opt2Comment = $("#dutyValOpt2Comment p:visible").toArray()
        .map((comment) => tools.convertElemToTextWithLinksForExport(comment))
        .join("||");
        result.render.opt1Comment = $("#dutyValOpt1Comment p:visible").toArray()
        .map((comment) => tools.convertElemToTextWithLinksForExport(comment))
        .join("||");
        
        return result;
    }

    openSubMenu(subItem, isOpenedByHash) {
        $('.calc-div-item').removeClass('active-item');

        const dataItem = $(`.calc-div-item[data-item = ${subItem}]`);
        dataItem.addClass('active-item');
        if (dataItem.hasClass('menu-item') || isOpenedByHash) {
            this.activeSubMenu = "";
        } else { 
            this.activeSubMenu = subItem;
        }
    }

    openCalcByHash() {
        const hash = this.getHash();
        if (!hash) {
            this.activeSubMenu = "";
        } else {
            const subMenuItem = $(`.submenu-item[data-claim="${hash}"]`); 
            if (subMenuItem.hasClass('menu-item')) {
                this.openSubMenu(subMenuItem.attr('data-item'));
            } else {
                this.openSubMenu(subMenuItem.closest(".submenu-group").attr('id'), true);
            }
        }
        
        if(this.isHashExist()) {
            const goalParams = {
                message: this.getHash(), 
                prefix: ""
            };
            this.sendStatisticMessage(goalParams);
        }

        this.autoSubmit();
    }

    showResults() {
        if (this.isHashExist()) {
            super.showResults();
        } else { //todo
            $('.calc-div-results').removeClass('show-results'); 
            $(".submenu-item").removeClass("active-item");
        }
    }

    isHashExist() {
        const subMenuItem = $(`.submenu-item[data-claim="${this.getHash()}"]`); 
        return subMenuItem.length > 0;
    }

    //show additional information only after 01.01.2022
    isSiriusTextShowed() {
        return (new Date(2022, 0, 1).valueOf() - new Date().valueOf()) <= 0;
    }

    drawLines() {
        const $calcDivMenu = $(".calc-div-menu");
        if ($calcDivMenu.position().left > 0) {
            $('#popupSubmenu').css('left', $calcDivMenu.position().left + $calcDivMenu.width() - $(window).scrollLeft() + 'px');
        }
    }
}

export {StatedutyCalculator};